function BackButton({ onClick, text = "← Zurück" }) {
  return (
    <button className="btn btn-back" onClick={onClick}>
      {text}
    </button>
  );
}

export default BackButton;
